import { atom, } from "jotai";
import type { ThemeName, } from "@bracket/ui/types";
import { setTheme, } from "@bracket/ui/themes";

const imported = import.meta.env?.VITE_DEFAULT_THEME as ThemeName | undefined;
const stored = globalThis.localStorage.getItem("bracket-ui-theme") as ThemeName | null;
const initialTheme: ThemeName = stored || imported || "dark";


/**
 * @summary
 *   In combination with the exported `themed()` function, this represents the lightest weight possible to trigger a re-render in react
 *   exactly once.
 * @description
 *   Jotai atom for managing the current theme mode (ThemeName).
 *   - Reads initial value from localStorage, env, or defaults to "dark".
 *   - When updated, persists theme using `setTheme`, and updates the atom value.
 * @usage
 *   const [theme, setTheme] = useAtom(themeModeAtom);
 *   setTheme("light");
 */
export const themeModeAtom = atom<ThemeName, [ThemeName], void>(
	initialTheme,
	(_, set, name) => {
		setTheme(name);
		set(themeModeAtom, name);
	},
);
